import styled, { css } from "styled-components";
import { IPropsButton } from ".";
import { Colors, SystemColos } from "../../settings/colors";
import { Link } from "react-router-dom";

const ButtonStyled = css`
    display: flex;
    align-items: center;
    justify-content: center;
    /* border: 1px solid ${Colors.Ink}; */
    padding: 10px;
    color: ${Colors.LightText};
    transition: color 0.3s, border-color 0.3s;
    align-self: baseline;
    border-radius: 4px;
    font-size: 1rem;

    :hover {
        opacity: 0.75;
        box-shadow: 1px 1px 4px 1px ${Colors.DarkBorder};
    }

    :disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const ButtonContainer = styled.button<IPropsButton>`
    ${ButtonStyled};

    background: ${({ variant, oulined }) =>
        oulined ? "transparent" : SystemColos[variant]};

    ${({ oulined, variant }) =>
        oulined &&
        css`
            border: 1px solid ${SystemColos[variant]};
            color: ${SystemColos[variant]};
        `}

    ${({ rounded }) =>
        rounded &&
        css`
            border-radius: 100%;
        `}
`;

export const ButtonContainerLinked = styled(Link)<IPropsButton>`
    ${ButtonStyled};

    background: ${({ variant, oulined }) =>
        oulined ? "transparent" : SystemColos[variant]};

    ${({ oulined, variant }) =>
        oulined &&
        css`
            border: 1px solid ${SystemColos[variant]};
            color: ${SystemColos[variant]};
        `}

    ${({ rounded }) =>
        rounded &&
        css`
            border-radius: 100%;
        `}
`;
